module.exports = __webpack_public_path__ + "img/2.4d59a3e0.png";